/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import WhyWealthyBroking from "./WhyWealthyBroking.container";

export default WhyWealthyBroking;
